import { QuerySkeleton } from "@dash/skeleton";
import { Navigate, useParams } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";
import { useClientManager } from "@megaron/react-clients";
import { Uuid } from "@megaron/uuid";

export const VisitRedirect = () => {
  const { uuid, visitId }: { uuid?: Uuid; visitId?: Uuid } = useParams();

  const visitUuid = uuid ?? visitId;

  const visitQuery = useClientManager("legacyMegarax")
    .visit()
    .useQuery({ uuid: visitUuid as Uuid }, { enabled: !!visitUuid });

  if (!visitUuid) {
    return <Navigate to={getMegaraxPath.uri("megarax://crm/customers")} />;
  }

  return (
    <QuerySkeleton query={visitQuery}>
      {(visit) => (
        <Navigate
          to={`${getMegaraxPath.uri("megarax://crm/customers/id/{id}", { id: visit.customerUuid })}?tab=historia`}
          replace
          state={{ scrollTo: `interaction-${visitUuid}` }}
        />
      )}
    </QuerySkeleton>
  );
};
